import React, {PureComponent} from "react";
import $ from "jquery";
import {Modal} from "react-responsive-modal";
import Alert from "react-s-alert";
import {confirmIdentity, confirmSession} from "../functions/api";
import SessionClosedModal from "../independentComponents/sessionClosedWarningModalComponent";
import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import Moment from "moment-timezone";
import parallel from "async/parallel";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;
const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const messagePort = process.env.REACT_APP_MESSAGE_PORT;

class OrganizerPanel extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            waiting: false,
            serverResult: <div/>,
            sessionDetails: {
                circuit: "---",
                circuit_id: -1,
                event_id: -1,
                length: 0,
                length_delimiter: "time",
                map_center_lat: 0,
                map_center_lng: 0,
                map_center_zoom_level: 0,
                map_rotation: 0,
                order_factor: "bestlap",
                session: "---",
                start_timestamp: 0,
                scheduled_start_timestamp: 0,
                timezone: "---",
                track_length: 0,
            },
            newLengthHours: 0,
            newLengthMinutes: 0,
            newStartHours: 0,
            newStartMinutes: 0,
            newStartSeconds: 0,
            newStartYesterday: false,
            sessionID: this.props.match ? this.props.match.params.sessionID : this.props.sessionID,
            eventID: this.props.match ? this.props.match.params.eventID : this.props.eventID,
            userID: this.props.match ? this.props.match.params.userID : this.props.userID,
            carList: this.props.match ? [{id: 0, livery_number: 0, title: "---"}] : this.props.carList,
            confirmedOrg: true,
            isSessionClosed: false,
            carSelectedForReset: -1,
            minutesToAdd: 0,
            categoryList: [],
            classToUpdateStatusID: -1,
            newClassStatus: -1,
            showManualAdjustLapTimeModal: false,
            lapBeingAdjusted: -1,
            carSelectedForLapAdjust: -1,
            newLapTime: -1,
            isLapTimeValid: false,
        };

        this.resetDevicesCommand = this.resetDevicesCommand.bind(this);
        this.resetTimerCommand = this.resetTimerCommand.bind(this);
        this.closeCommand = this.closeCommand.bind(this);
        this.changeLengthCommand = this.changeLengthCommand.bind(this);
        this.changeStartTimestampCommand = this.changeStartTimestampCommand.bind(this);
        this.resetIndividualDeviceCommand = this.resetIndividualDeviceCommand.bind(this);
        this.markClassStatus = this.markClassStatus.bind(this);

        this.resetSessionTimer = this.resetSessionTimer.bind(this);
        this.closeSession = this.closeSession.bind(this);
        this.changeSessionLength = this.changeSessionLength.bind(this);
        this.changeStartTimestamp = this.changeStartTimestamp.bind(this);
        this.incrementMinutes = this.incrementMinutes.bind(this);

        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleConfirmAction = this.handleConfirmAction.bind(this);
        this.handleChangeLengthHours = this.handleChangeLengthHours.bind(this);
        this.handleChangeLengthMinutes = this.handleChangeLengthMinutes.bind(this);
        this.handleChangeStartHours = this.handleChangeStartHours.bind(this);
        this.handleChangeStartMinutes = this.handleChangeStartMinutes.bind(this);
        this.handleChangeStartSeconds = this.handleChangeStartSeconds.bind(this);
        this.handleChangeStartYesterday = this.handleChangeStartYesterday.bind(this);
        this.handleCarChangeForReset = this.handleCarChangeForReset.bind(this);
        this.handleChangeIncrementMinutes = this.handleChangeIncrementMinutes.bind(this);
        this.handleShowClassStatusChangeModal = this.handleShowClassStatusChangeModal.bind(this);
        this.handleClassToUpdateStatusChange = this.handleClassToUpdateStatusChange.bind(this);
        this.handleClassNewStatusChange = this.handleClassNewStatusChange.bind(this);
        this.handleShowModalManualAdjustVehicleLapTime = this.handleShowModalManualAdjustVehicleLapTime.bind(this);
        this.handleChangeLapBeingAdjusted = this.handleChangeLapBeingAdjusted.bind(this);
        this.handleCarChangeLapAdjustment = this.handleCarChangeLapAdjustment.bind(this);
        this.handleManualAdjustVehicleLapTime = this.handleManualAdjustVehicleLapTime.bind(this);

        this.evaluateLapTime = this.evaluateLapTime.bind(this);

        this.popoutLiveMaxes = this.popoutLiveMaxes.bind(this);
        this.popoutPitLaneSpeed = this.popoutPitLaneSpeed.bind(this);
        this.popoutDiagnostics = this.popoutDiagnostics.bind(this);
        this.popoutFlagMonitor = this.popoutFlagMonitor.bind(this);
        this.popoutDriverSeatTime = this.popoutDriverSeatTime.bind(this);

        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.getCarList = this.getCarList.bind(this);
        this.getCategoryList = this.getCategoryList.bind(this);
    }

    /* COMPONENT LIFECYCLE */
    componentDidMount() {
        confirmIdentity(this.props.cookies.get("authToken"), this.state.userID, this.state.eventID, (confirmed) => {
            if (!confirmed) {
                this.setState({
                    confirmedOrg: false,
                });
            } else {
                const helper = this;
                parallel([
                    function (callback) {
                        helper.getSessionDetails((status) => {
                            callback(null, status);
                        });
                    },
                    function (callback) {
                        helper.getCategoryList((status) => {
                            callback(null, status);
                        });
                    },
                    function (callback) {
                        if (helper.props.match) {
                            // Is a popped out window, must retrieve car list
                            helper.getCarList((status) => {
                                callback(null, status);
                            });
                        } else {
                            callback(null, "ok");
                        }
                    }
                ], function (err, result) {
                    console.log("[ORGANIZER PANEL] Data retrieval COMPLETE");
                });
            }
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.carList) !== JSON.stringify(this.props.carList)) {
            if (!this.props.match) {
                this.setState({
                    carList: this.props.carList,
                });
            }
        }
    }

    /* SETUP INFO */
    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getSessionDetails",
            dataType: "json",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
            },
            success: function (data) {
                const today = Moment();
                const start_timestamp = Moment(data.start_timestamp * 1000);
                helper.setState({
                    sessionDetails: data,
                    newLengthHours: Math.floor(data.length / 3600),
                    newLengthMinutes: (data.length % 3600) / 60,
                    newStartHours: start_timestamp.hours(),
                    newStartMinutes: start_timestamp.minutes(),
                    newStartSeconds: start_timestamp.seconds(),
                    newStartYesterday: ((today.date() - 1) === start_timestamp.date()),
                }, () => {
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
                callback("nok");
            }
        });
    }

    getCarList(callback) {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getCarList",
            headers: {
                "authorization": helper.props.cookies.get("authToken"),
            },
            data: {
                userID: helper.state.userID,
                sessionID: helper.state.sessionID,
            },
            success: function (data) {
                helper.setState({
                    carList: data,
                }, () => {
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
                helper.setState({
                    carList: [{
                        id: 0, livery_number: 0, title: "---"
                    }]
                }, () => {
                    callback("nok");
                });
            }
        });
    }

    getCategoryList(callback) {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/getClassList",
            headers: {
                "authorization": helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.state.sessionID,
            },
            success: function (data) {
                helper.setState({
                    categoryList: data,
                }, () => {
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error("Error:", err);
                }
                helper.setState({
                    categoryList: []
                }, () => {
                    callback("nok");
                });
            }
        });
    }

    /* MESSAGE TO BROKER */
    resetDevicesCommand() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/command-worker-device?command=RT-ORG-SESSION-RESET&eventId=" + helper.state.sessionDetails.event_id + "&sessionId=" + helper.state.sessionID + "&userId=" + helper.state.userID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function () {
                console.log("[ORGANIZER PANEL] Successfully sent session devices reset request.");
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
            }, error: function (err) {
                if (err) {
                    console.error("Error sending session devices reset request.");
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        }).done(function () {
            setTimeout(() => {
                helper.setState({
                    serverResult: <div/>
                });
                helper.handleCloseModal();
            }, 1500);
        });
    }

    resetIndividualDeviceCommand() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/command-worker-device?command=RT-ORG-CAR-SESSION-RESET&eventId=" + helper.state.sessionDetails.event_id + "&sessionId=" + helper.state.sessionID + "&userId=" + helper.state.userID + "&carId=" + helper.state.carSelectedForReset,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function () {
                console.log("[ORGANIZER PANEL] Successfully sent reset request to vehicle ID " + helper.state.carSelectedForReset);
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
            }, error: function (err) {
                if (err) {
                    console.error("Error sending session reset request to vehicle ID" + helper.state.carSelectedForReset);
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        }).done(function () {
            setTimeout(() => {
                helper.setState({
                    serverResult: <div/>
                });
                helper.handleCloseModal();
            }, 1500);
        });
    }

    resetTimerCommand() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/command-worker-device?command=RT-ORG-SESSION-TIMER-RESET&eventId=" + helper.state.sessionDetails.event_id + "&sessionId=" + helper.state.sessionID + "&userId=" + helper.state.userID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: () => {
                console.log("[ORGANIZER PANEL] Successfully sent session timer reset request.");
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
            }, error: (err) => {
                if (err) {
                    console.error("Error sending session timer reset request.");
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        }).done(() => {
            setTimeout(() => {
                helper.setState({
                    serverResult: <div/>
                });
                helper.handleCloseModal();
            }, 1500);
        });
    }

    closeCommand() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/command-worker-device?command=RT-ORG-SESSION-CLOSE&eventId=" + helper.state.sessionDetails.event_id + "&sessionId=" + helper.state.sessionID + "&userId=" + helper.state.userID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function () {
                console.log("[ORGANIZER PANEL] Successfully sent session reset request.");
            }, error: function (err) {
                if (err)
                    console.error("Error sending session reset request.");
            }
        });
    }

    changeLengthCommand() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/command-worker-device?command=RT-ORG-SESSION-CHANGE-LENGTH&eventId=" + helper.state.sessionDetails.event_id + "&sessionId=" + helper.state.sessionID + "&userId=" + helper.state.userID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function () {
                console.log("[ORGANIZER PANEL] Successfully sent session reset request.");
            }, error: function (err) {
                if (err)
                    console.error("Error sending session reset request.");
            }
        });
    }

    changeStartTimestampCommand() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/command-worker-device?command=RT-ORG-SESSION-CHANGE-START&eventId=" + helper.state.sessionDetails.event_id + "&sessionId=" + helper.state.sessionID + "&userId=" + helper.state.userID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            dataType: "json",
            success: function () {
                console.log("[ORGANIZER PANEL] Successfully sent session start_timestamp change request.");
            }, error: function (err) {
                if (err)
                    console.error("Error sending session reset request.");
            }
        });
    }

    resetSessionTimer() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/resetSessionTimer",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                newDate: Moment().unix(),
            },
            success: function () {
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
                helper.resetTimerCommand();
            }, error: function (err) {
                if (err) {
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        }).done(function () {
            setTimeout(function () {
                helper.setState({
                    serverResult: <div/>
                });
                helper.handleCloseModal();
            }, 1500);
        });
    }

    closeSession() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/closeSession",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                endDate: Moment().unix(),
            },
            success: function () {
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
                helper.closeCommand();
            }, error: function (err) {
                if (err) {
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        }).done(function () {
            setTimeout(() => {
                helper.setState({
                    serverResult: <div/>
                });
                helper.handleCloseModal();
                window.close();
            }, 1500);
        });
    }

    changeSessionLength() {
        let newLength;
        if (this.state.sessionDetails.length_delimiter === "time") {
            newLength = (this.state.newLengthHours * 3600) + (this.state.newLengthMinutes * 60);
        } else {
            // TODO
            newLength = 0;
        }

        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/changeSessionLength",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                newLength: newLength
            },
            success: function () {
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
                helper.changeLengthCommand();
            }, error: function (err) {
                if (err) {
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        }).done(function () {
            setTimeout(() => {
                helper.setState({
                    serverResult: <div/>
                });
                helper.handleCloseModal();
            }, 1500);
        });
    }

    changeStartTimestamp() {
        let now = Moment();
        let newTimestamp = Moment({
            year: now.year(),
            month: now.month(),
            day: (this.state.newStartYesterday ? now.date() - 1 : now.date()),
            hour: this.state.newStartHours,
            minute: this.state.newStartMinutes,
            seconds: this.state.newStartSeconds
        });

        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/changeSessionStartTimestamp",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                newTimestamp: newTimestamp.unix()
            },
            success: function () {
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
                helper.changeStartTimestampCommand();
            }, error: function (err) {
                if (err) {
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        }).done(function () {
            setTimeout(() => {
                helper.setState({
                    serverResult: <div/>
                });
                helper.handleCloseModal();
            }, 1500);
        });
    }

    incrementMinutes() {
        let newLength;
        if (this.state.sessionDetails.length_delimiter === "time") {
            newLength = this.state.sessionDetails.length + (this.state.minutesToAdd * 60);
        } else {
            // TODO
            newLength = 0;
        }

        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/changeSessionLength",
            headers: {
                "authorization": helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.state.sessionID,
                newLength: newLength
            },
            success: function () {
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
                helper.changeLengthCommand();
            }, error: function (err) {
                if (err) {
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        }).done(function () {
            setTimeout(() => {
                helper.setState({
                    serverResult: <div/>
                });
                helper.handleCloseModal();
            }, 1500);
        });
    }

    markClassStatus() {
        const helper = this;
        $.ajax({
            type: "POST",
            url: serverIP + ":" + backendPort + "/dashboard/changeClassStatus",
            headers: {
                "authorization": helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.state.sessionID,
                newStatus: helper.state.newClassStatus,
                classID: helper.state.classToUpdateStatusID
            },
            success: function (data) {
                helper.handleCloseModal();
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("changeStatusSuccess") + '!</span>', {
                    position: "top-right",
                    effect: "genie",
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                helper.handleCloseModal();
                if (err) {
                    console.error("Error:", err);
                }
                Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("changeStatusError") + '!</span>', {
                    position: "top-right",
                    effect: "genie",
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }
        });
    }

    /* EVENT HANDLERS */
    handleShowModal(e) {
        let actionType = e.target.value;
        // Confirm if session is open
        confirmSession(this.props.cookies.get("authToken"), this.state.eventID, this.state.sessionID, (isClosed) => {
            if (isClosed) {
                this.setState({
                    isSessionClosed: true,
                });
            } else {
                this.setState({
                    show: true,
                    actionType: actionType,
                });
            }
        });
    }

    handleCloseModal() {
        this.setState({
            show: false,
            showStatusChange: false,
            showManualAdjustLapTimeModal: false,
            serverResult: <div/>,
            newClassStatus: -1,
            classToUpdateStatusID: -1,
            carSelectedForReset: -1,
            carSelectedForLapAdjust: -1
        });
    }

    handleShowClassStatusChangeModal(e) {
        // Confirm if session is open
        confirmSession(this.props.cookies.get("authToken"), this.state.eventID, this.state.sessionID, (isClosed) => {
            if (isClosed) {
                this.setState({
                    isSessionClosed: true,
                });
            } else {
                this.setState({
                    showStatusChange: true,
                });
            }
        });
    }

    handleConfirmAction() {
        switch (this.state.actionType) {
            case "resetSessionTimer": {
                this.resetSessionTimer();
                break;
            }
            case "resetSessionDevices": {
                this.resetDevicesCommand();
                break;
            }
            case "resetSingleSessionDevice": {
                this.resetIndividualDeviceCommand();
                break;
            }
            case "closeSession": {
                this.closeSession();
                break;
            }
            case "changeLength": {
                this.changeSessionLength();
                break;
            }
            case "changeTimestamp": {
                this.changeStartTimestamp();
                break;
            }
            case "incrementMinutes": {
                this.incrementMinutes();
                break;
            }
            default: {
                break;
            }
        }
    }

    handleCarChangeForReset(e) {
        this.setState({
            carSelectedForReset: parseInt(e.target.value),
        });
    }

    handleChangeLengthHours(e) {
        this.setState({
            newLengthHours: e.target.value,
        });
    }

    handleChangeLengthMinutes(e) {
        this.setState({
            newLengthMinutes: e.target.value,
        });
    }

    handleChangeStartHours(e) {
        this.setState({
            newStartHours: e.target.value,
        });
    }

    handleChangeStartMinutes(e) {
        this.setState({
            newStartMinutes: e.target.value,
        });
    }

    handleChangeStartSeconds(e) {
        this.setState({
            newStartSeconds: e.target.value,
        });
    }

    handleChangeStartYesterday() {
        this.setState({
            newStartYesterday: !this.state.newStartYesterday,
        });
    }

    handleChangeIncrementMinutes(e) {
        let minutesToAdd = parseInt(e.target.value);
        this.setState({
            minutesToAdd: minutesToAdd,
        });
    }

    handleClassToUpdateStatusChange(e) {
        let clickValue = parseInt(e.target.value);
        if (this.state.classToUpdateStatusID < 0) {
            this.setState({
                classToUpdateStatusID: clickValue,
            });
        } else {
            this.setState({
                classToUpdateStatusID: (this.state.classToUpdateStatusID === clickValue ? -1 : clickValue),
            });
        }
    }

    handleClassNewStatusChange(e) {
        let clickValue = parseInt(e.target.value);
        if (this.state.newClassStatus < 0) {
            this.setState({
                newClassStatus: clickValue,
            });
        } else {
            this.setState({
                newClassStatus: (this.state.newClassStatus === clickValue ? -1 : clickValue),
            });
        }
    }

    handleShowModalManualAdjustVehicleLapTime(e) {
        // Confirm if session is open
        confirmSession(this.props.cookies.get("authToken"), this.state.eventID, this.state.sessionID, (isClosed) => {
            if (isClosed) {
                this.setState({
                    isSessionClosed: true,
                });
            } else {
                this.setState({
                    showManualAdjustLapTimeModal: true,
                });
            }
        });
    }

    handleChangeLapBeingAdjusted(e) {
        let lap = parseInt(e.target.value);
        this.setState({
            lapBeingAdjusted: isNaN(lap) ? -1 : parseInt(lap),
        });
    }

    handleCarChangeLapAdjustment(e) {
        let carID = parseInt(e.target.value);
        this.setState({
            carSelectedForLapAdjust: isNaN(carID) ? -1 : carID,
        });
    }

    handleManualAdjustVehicleLapTime(e) {
        const helper = this;
        $.ajax({
            type: "POST",
            url: telemetryIP + ":" + messagePort + "/session-car-best-lap-manual-adjust?carId=" + this.state.carSelectedForLapAdjust + "&sessionId=" + this.state.sessionID,
            headers: {
                "Authorization": "Basic " + btoa("admin:vZ3s4T7MJfWhHD5H")
            },
            data: JSON.stringify({
                bestLapDetails: {
                    lapTime: helper.state.newLapTime,
                    lapNumber: helper.state.lapBeingAdjusted,
                }
            }),
            dataType: "json",
            success: function () {
                console.log("[ORGANIZER PANEL] Successfully sent lap adjustment request.");
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("changeStatusSuccess") + '!</span>', {
                    position: "top-right",
                    effect: "genie",
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                if (err) {
                    console.error("[ORGANIZER PANEL] Error sending lap adjustment request:", e);
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("changeStatusError") + '!</span>', {
                        position: "top-right",
                        effect: "genie",
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                }
            }
        });
    }

    evaluateLapTime(e) {
        let input = e.target.value;
        let parts = input.split(":");
        if (parts.length === 3) {
            let hours = parseInt(parts[0]);
            let minutes = parseInt(parts[1]);
            let millis = Math.round(parseFloat(parts[2]) * 1000);
            if (
                parts[2].length === 6 &&
                !isNaN(hours) &&
                !isNaN(minutes) &&
                !isNaN(millis) &&
                hours >= 0 &&
                (minutes >= 0 && minutes <= 59) &&
                (millis >= 0.0 && millis <= 59999)
            ) {
                this.setState({
                    isLapTimeValid: true,
                    newLapTime: ((hours * 60 * 60 * 1000) + (minutes * 60 * 1000) + millis),
                });
            } else {
                if (this.state.isLapTimeValid) {
                    this.setState({
                        isLapTimeValid: false,
                        newLapTime: -1,
                    });
                }
            }
        } else {
            if (this.state.isLapTimeValid) {
                this.setState({
                    isLapTimeValid: false,
                    newLapTime: -1,
                });
            }
        }
    }

    /* POPOUT METHODS */
    popoutLiveMaxes(e) {
        e.preventDefault();
        window.open(
            "/liveMaxes/" + this.state.eventID + "/" + this.state.sessionID + "/" + this.state.userID,
            "liveMaxes",
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    popoutPitLaneSpeed(e) {
        e.preventDefault();
        window.open(
            "/livePitSpeed/" + this.state.eventID + "/" + this.state.sessionID + "/" + this.state.userID,
            "livePitSpeed",
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    popoutDiagnostics(e) {
        e.preventDefault();
        window.open(
            "/diagnostic/" + this.state.eventID + "/" + this.state.sessionID + "/" + this.state.userID,
            "diagnostic",
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    popoutFlagMonitor(e) {
        e.preventDefault();
        window.open(
            "/flagMonitor/" + this.state.eventID + "/" + this.state.sessionID + "/" + this.state.userID,
            "flags",
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=1300"
        );
    }

    popoutDriverSeatTime(e) {
        e.preventDefault();
        window.open(
            "/seatTimeMonitor/" + this.state.eventID + "/" + this.state.sessionID + "/" + this.state.userID,
            "flags",
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,width=1000,height=600"
        );
    }

    /* RENDER */

    render() {
        if (this.state.confirmedOrg) {
            return (
                <div className={"container-fluid w3-animate-fading"}>
                    <Alert stack={{limit: 10}} html={true}/>
                    <ul className={"organizerPanel_title nav nav-tabs"} role={"tablist"}>
                        <li className={"active"}>
                            <a className={"text-center"} href={"#monitors"} role={"tab"} data-toggle={"tab"}>
                                {this.props.t("monitors")}
                            </a>
                        </li>
                        <li>
                            <a className={"text-center"} href={"#sessionControls"} role={"tab"} data-toggle={"tab"}>
                                {this.props.t("sessionControls")}
                            </a>
                        </li>
                    </ul>
                    <div className={"tab-content"}>
                        <div className={"tab-pane fade active in"} id={"monitors"}>
                            <div className={"organizerPanel_customContainer"}>
                                <div className={"row row-flex"} style={{padding: 0}}>
                                    <div className={"col-xs-12 text-left organizer_panel_title"}>
                                        <span className={"App_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("raceMarshal")}</span>
                                    </div>
                                    <div className={"col-xs-12"}>
                                        <MonitorCard
                                            monitorName={this.props.t("flagMonitoringApp")}
                                            monitorDesc={this.props.t("flagShortDesc")}
                                            monitorMethod={this.popoutFlagMonitor}
                                            isDisabled={false}
                                            t={this.props.t}
                                        />
                                    </div>
                                    <div className={"col-xs-12 text-left organizer_panel_title"}>
                                        <span className={"App_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("raceControl")}</span>
                                    </div>
                                    <div className={"col-xs-12"}>
                                        <MonitorCard
                                            monitorName={this.props.t("maxValuesApp")}
                                            monitorDesc={this.props.t("maxValuesShortDesc")}
                                            monitorMethod={this.popoutLiveMaxes}
                                            isDisabled={false}
                                            t={this.props.t}
                                        />
                                        <MonitorCard
                                            monitorName={this.props.t("pitMonitorApp")}
                                            monitorDesc={this.props.t("pitMonitorShortDesc")}
                                            monitorMethod={this.popoutPitLaneSpeed}
                                            isDisabled={false}
                                            t={this.props.t}
                                        />
                                        <MonitorCard
                                            monitorName={this.props.t("driverSeatTimeApp")}
                                            monitorDesc={this.props.t("driverSeatTimeAppDesc")}
                                            monitorMethod={this.popoutDriverSeatTime}
                                            isDisabled={false}
                                            t={this.props.t}
                                        />
                                    </div>
                                    <div className={"col-xs-12 text-left organizer_panel_title"}>
                                        <span className={"App_title"} style={{fontStyle: "italic", fontSize: 25}}>{this.props.t("maintenance")}</span>
                                    </div>
                                    <div className={"col-xs-12"}>
                                        <MonitorCard
                                            monitorName={this.props.t("deviceDiagnosticApp")}
                                            monitorDesc={this.props.t("deviceDiagnosticAppShortDesc")}
                                            monitorMethod={this.popoutDiagnostics}
                                            isDisabled={false}
                                            t={this.props.t}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"tab-pane fade"} id={"sessionControls"}>
                            <div className={"container-fluid organizerPanel_customContainer"}>
                                <div className={"row"} style={{textAlign: "left", marginTop: 10}}>
                                    <div className={"col-xs-12"}>
                                        <span className={"organizerPanel_title"}>{this.props.t("devices")}</span>
                                        <hr style={{marginTop: 0}}/>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-xs-6"}>
                                        <button className={"btn btn-lg btn-primary btn-block button"}
                                                value={"resetSessionDevices"}
                                                onClick={this.handleShowModal}
                                                style={{whiteSpace: "normal"}}
                                        >
                                            <i className={"fas fa-flag organizerPanel_iconStyle"}/>
                                            <span className={"organizerPanel_button"} style={{pointerEvents: "none"}}>{this.props.t("sendBroadcastReset")}</span>
                                        </button>
                                    </div>
                                    <div className={"col-xs-6"}>
                                        <div className={"col-xs-12"} style={{padding: 0}}>
                                            <button className={"btn btn-lg btn-primary btn-block button"}
                                                    value={"resetSingleSessionDevice"}
                                                    onClick={this.handleShowModal}
                                                    style={{whiteSpace: "normal"}}
                                            >
                                                <i className={"fas fa-flag organizerPanel_iconStyle"}/>
                                                <span className={"organizerPanel_button"}>{this.props.t("sendIndividualReset")}</span>
                                            </button>
                                        </div>
                                        <div className={"col-xs-12"}>
                                            <select
                                                className={"form-control"}
                                                style={{marginTop: 8}}
                                                onChange={this.handleCarChangeForReset}
                                            >
                                                <option value="">{this.props.t("selectACar")} ...</option>
                                                {this.state.carList.map((car, i) => {
                                                    return (
                                                        <option key={car.id} value={car.id}>{car.livery_number} | {car.team_name}</option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className={"row"} style={{textAlign: "left", marginTop: 10}}>
                                    <div className={"col-xs-12"}>
                                        <span className={"organizerPanel_title"}>{this.props.t("timer")}</span>
                                        <hr style={{marginTop: 0}}/>
                                    </div>
                                </div>
                                <div className={"row row-flex"}>
                                    <div className={"col-xs-12 col-sm-6 vcenter form-group"}>
                                        <button className={"btn btn-lg btn-primary btn-block button"}
                                                value={"resetSessionTimer"}
                                                onClick={this.handleShowModal}
                                                style={{whiteSpace: "normal"}}
                                        >
                                            <i className={"fas fa-flag organizerPanel_iconStyle"}/>
                                            <span className={"organizerPanel_button"}>{this.props.t("resetTimer")}</span>
                                        </button>
                                    </div>

                                    <div className={"col-xs-12 col-sm-6 row-flex form-group"}>
                                        <div className={"col-xs-8 vcenter"} style={{padding: 0}}>
                                            <button className={"btn btn-lg btn-primary btn-block button"}
                                                    onClick={this.handleShowModal}
                                                    value={"changeLength"}
                                                    style={{whiteSpace: "normal"}}
                                            >
                                                <i className={"far fa-clock organizerPanel_iconStyle"}/>
                                                <span className={"organizerPanel_button"}>{this.props.t("changeSessionLength")}</span>
                                            </button>
                                        </div>
                                        <div className={"col-xs-3"} style={{margin: 2}}>
                                            {this.state.sessionDetails.length_delimiter === "time" ? (
                                                <div className={"row row-flex"}>
                                                    <div className={"col-xs-12"} style={{padding: 0}}>
                                                        <div className={"col-xs-9 col-sm-9"}>
                                                            <input
                                                                className={"form-control App_black_text text-right"}
                                                                style={{border: "2px solid #ed2126"}}
                                                                type={"number"}
                                                                value={this.state.newLengthHours}
                                                                placeholder={this.props.t("enterValue")}
                                                                onChange={this.handleChangeLengthHours}
                                                            />
                                                        </div>
                                                        <div className={"col-xs-3"} style={{padding: 0, textAlign: "left"}}>
                                                            <label className={"organizerPanel_text"}>hr</label>
                                                        </div>
                                                    </div>
                                                    <div className={"col-xs-12"} style={{padding: 0}}>
                                                        <div className={"col-xs-9 col-sm-9"}>
                                                            <input
                                                                className={"form-control App_black_text text-right"}
                                                                style={{border: "2px solid #ed2126"}}
                                                                type={"number"}
                                                                value={this.state.newLengthMinutes}
                                                                placeholder={this.props.t("enterValue")}
                                                                onChange={this.handleChangeLengthMinutes}
                                                            />
                                                        </div>
                                                        <div className={"col-xs-3"} style={{padding: 0, textAlign: "left"}}>
                                                            <label className={"organizerPanel_text"}>min</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div/>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={"row row-flex"}>
                                    <div className={"col-xs-12 col-sm-6 row-flex"}>
                                        <div className={"col-sm-8 vcenter"} style={{padding: 0}}>
                                            <button className={"btn btn-lg btn-primary btn-block button"}
                                                    onClick={this.handleShowModal}
                                                    value={"incrementMinutes"}
                                                    style={{whiteSpace: "normal"}}
                                            >
                                                <i className={"far fa-clock organizerPanel_iconStyle"}/>
                                                <span className={"organizerPanel_button"}>{this.props.t("incrementMinutes")}</span>
                                            </button>
                                        </div>
                                        <div className={"col-xs-4 form-group vcenter"} style={{margin: 0}}>
                                            <input
                                                className={"form-control App_black_text text-right"}
                                                style={{border: "2px solid #ed2126"}}
                                                type={"number"}
                                                placeholder={this.props.t("enterValue")}
                                                onChange={this.handleChangeIncrementMinutes}
                                            />
                                            <label className={"control-label organizerPanel_title"}>min</label>
                                        </div>
                                    </div>
                                    <div className={"col-xs-12 col-sm-6"}>
                                        <div className={"col-xs-12 row-flex form-group"} style={{padding: 0}}>
                                            {(this.state.sessionDetails.length_delimiter === "time") ? (
                                                <>
                                                    <SessionClosedModal isSessionClosed={this.state.isSessionClosed}/>

                                                    <div className={"col-sm-3 vcenter"} style={{padding: 0, justifyContent: "left"}}>
                                                        <label className={"control control-checkbox"}>
                                                            <input
                                                                type={"checkbox"}
                                                                onClick={this.handleChangeStartYesterday}
                                                            />
                                                            <div className={"control_indicator"}>
                                                                <span className={"control-label organizerPanel_title"} style={{marginLeft: 25}}>
                                                                    {this.props.t("yesterday")}
                                                                </span>
                                                            </div>
                                                        </label>
                                                    </div>

                                                    <div className={"col-xs-3 form-group vcenter text-right"} style={{padding: 5}}>
                                                        <input
                                                            className={"form-control App_black_text"}
                                                            style={{border: "2px solid #ed2126"}}
                                                            type={"number"}
                                                            value={this.state.newStartHours}
                                                            placeholder={"HH"}
                                                            onChange={this.handleChangeStartHours}
                                                        />
                                                        <label className={"control-label organizerPanel_title"}>hr</label>
                                                    </div>

                                                    <div className={"col-xs-3 form-group vcenter text-right"} style={{padding: 5}}>
                                                        <input
                                                            className={"form-control App_black_text"}
                                                            style={{border: "2px solid #ed2126"}}
                                                            type={"number"}
                                                            value={this.state.newStartMinutes}
                                                            placeholder={"MM"}
                                                            onChange={this.handleChangeStartMinutes}
                                                        />
                                                        <label className={"control-label organizerPanel_title"}>min</label>
                                                    </div>

                                                    <div className={"col-xs-3 form-group vcenter text-right"} style={{padding: 5}}>
                                                        <input
                                                            className={"form-control App_black_text"}
                                                            style={{border: "2px solid #ed2126"}}
                                                            type={"number"}
                                                            value={this.state.newStartSeconds}
                                                            placeholder={"SS"}
                                                            onChange={this.handleChangeStartSeconds}
                                                        />
                                                        <label className={"control-label organizerPanel_title"}>sec</label>
                                                    </div>
                                                </>
                                            ) : (
                                                <div/>
                                            )}
                                        </div>
                                        <div className={"col-xs-12"}>
                                            <button className={"btn btn-lg btn-primary btn-block button"}
                                                    onClick={this.handleShowModal}
                                                    value={"changeTimestamp"}
                                                    style={{whiteSpace: "normal"}}
                                            >
                                                <i className={"far fa-clock organizerPanel_iconStyle"}/>
                                                <span className={"organizerPanel_button"}>{this.props.t("changeStartTimestamp")}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className={"col-sm-12"} style={{textAlign: "left", marginTop: 10}}>
                                    <span className={"organizerPanel_title"}>{this.props.t("session")}</span>
                                    <hr style={{marginTop: 0}}/>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-sm-4"} style={{marginBottom: 5}}>
                                        <button className={"btn btn-lg btn-primary btn-block button"}
                                                onClick={this.handleShowClassStatusChangeModal}
                                                style={{whiteSpace: "normal"}}
                                        >
                                            <i className={"fas fa-hand-paper organizerPanel_iconStyle"}/>
                                            <span className={"organizerPanel_button"}>{this.props.t("markClassStatus")}</span>
                                        </button>
                                    </div>
                                    <div className={"col-sm-4"} style={{marginBottom: 5}}>
                                        <button className={"btn btn-lg btn-primary btn-block button"}
                                                onClick={this.handleShowModal}
                                                value={"closeSession"}
                                                style={{whiteSpace: "normal"}}
                                        >
                                            <i className={"fas fa-power-off organizerPanel_iconStyle"}/>
                                            <span className={"organizerPanel_button"}>{this.props.t("closeCurrentSession")}</span>
                                        </button>
                                    </div>
                                    <div className={"col-sm-4"} style={{marginBottom: 5}}>
                                        <button className={"btn btn-lg btn-primary btn-block button"}
                                                onClick={this.handleShowModalManualAdjustVehicleLapTime}
                                                value={"adjustBestLap"}
                                                style={{whiteSpace: "normal"}}
                                        >
                                            <i className="fas fa-stopwatch organizerPanel_iconStyle"/>
                                            <span className={"organizerPanel_button"}>{this.props.t("adjustBestLap")}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal open={this.state.show}
                           onClose={this.handleCloseModal}
                           center={false}
                           classNames={{modal: "small-modal"}}
                           showCloseIcon={false}
                    >
                        <div className={"modal-header"}>
                            <div className={"modal-title"}>
                                <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("areYouSure")}</b>
                            </div>
                        </div>
                        <div className={"modal-body"}>
                            <b className={"App_smallHeader"} style={{color: "#000000"}}>{this.props.t("actionIrreversibleWarning")}</b>
                            {this.state.waiting ? (
                                <div className={"alert alert-warning"} role={"alert"}>
                                    {this.props.t("waitingForServer")}...
                                </div>
                            ) : (
                                <div/>
                            )}
                            {this.state.serverResult}
                        </div>
                        <div className={"modal-footer"}>
                            <button
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                                onClick={this.handleConfirmAction}
                            >{this.props.t("yes").toUpperCase()}
                            </button>
                            <button
                                onClick={this.handleCloseModal}
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                            >{this.props.t("no").toUpperCase()}
                            </button>
                        </div>
                    </Modal>
                    <Modal open={this.state.showStatusChange}
                           onClose={this.handleCloseModal}
                           center={false}
                           classNames={{modal: "small-modal"}}
                           showCloseIcon={false}
                    >
                        <div className={"modal-header"}>
                            <div className={"modal-title"}>
                                <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("areYouSure")}</b>
                            </div>
                        </div>
                        <div className={"modal-body"}>
                            <b className={"App_black_text"} style={{color: "#000000"}}>{this.props.t("markClassWarning")}</b>
                            <div className={"row"}>
                                <div className={"col-xs-12"}>
                                    <span className={"App_small_title"} style={{fontStyle: "italic", fontSize: 19}}>{this.props.t("class")}</span>
                                    <hr style={{margin: 2, borderColor: "#000000"}}/>
                                    <div className={"btn-toolbar"}>
                                        {this.state.categoryList.map((category) => {
                                            return (
                                                <button className={"btn App_header button"}
                                                        key={"class_" + category.id}
                                                        style={this.state.classToUpdateStatusID === category.id ? {} : {backgroundColor: "#4b4b4b"}}
                                                        value={category.id}
                                                        onClick={this.handleClassToUpdateStatusChange}
                                                >
                                                    {category.description.toUpperCase()}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className={"row"} style={{marginTop: 10}}>
                                <div className={"col-xs-12"}>
                                    <span className={"App_small_title"} style={{fontStyle: "italic", fontSize: 19}}>{this.props.t("state")}</span>
                                    <hr style={{margin: 2, borderColor: "#000000"}}/>
                                    <div className={"btn-toolbar"}>
                                        <button className={"btn App_header button"}
                                                style={this.state.newClassStatus === 0 ? {} : {backgroundColor: "#4b4b4b", color: "#FFFFFF"}}
                                                value={"0"}
                                                onClick={this.handleClassNewStatusChange}
                                        >
                                            {this.props.t("finished").toUpperCase()}
                                        </button>
                                        <button className={"btn App_header button"}
                                                style={this.state.newClassStatus === 1 ? {} : {backgroundColor: "#4b4b4b", color: "#FFFFFF"}}
                                                value={"1"}
                                                onClick={this.handleClassNewStatusChange}
                                        >
                                            {this.props.t("racing").toUpperCase()}
                                        </button>
                                        <button className={"btn App_header button"}
                                                style={this.state.newClassStatus === 2 ? {} : {backgroundColor: "#4b4b4b", color: "#FFFFFF"}}
                                                value={"2"}
                                                onClick={this.handleClassNewStatusChange}
                                        >
                                            {this.props.t("dnf").toUpperCase()}
                                        </button>
                                        <button className={"btn App_header button"}
                                                style={this.state.newClassStatus === 3 ? {} : {backgroundColor: "#4b4b4b", color: "#FFFFFF"}}
                                                value={"3"}
                                                onClick={this.handleClassNewStatusChange}
                                        >
                                            {this.props.t("dns").toUpperCase()}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            {(this.state.classToUpdateStatusID >= 0 && this.state.newClassStatus >= 0) ? (
                                <button
                                    onClick={this.markClassStatus}
                                    className={"btn App_header button"}
                                    style={{background: "#ff0003", color: "#FFFFFF"}}
                                >{this.props.t("confirm").toUpperCase()}
                                </button>
                            ) : null}
                            <button
                                onClick={this.handleCloseModal}
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                            >{this.props.t("cancel").toUpperCase()}
                            </button>
                        </div>
                    </Modal>
                    <Modal open={this.state.showManualAdjustLapTimeModal}
                           onClose={this.handleCloseModal}
                           center={false}
                           classNames={{modal: "medium-modal"}}
                           showCloseIcon={false}
                    >
                        <div className={"modal-header"}>
                            <div className={"modal-title"}>
                                <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("adjustBestLap")}</b>
                            </div>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"row"}>
                                <div className={"col-xs-5"}>
                                    <label className={"App_text"}>{this.props.t("selectACar")}</label>
                                    <select
                                        className={"form-control"}
                                        style={{marginTop: 8}}
                                        onChange={this.handleCarChangeLapAdjustment}
                                    >
                                        <option value="-1">{this.props.t("selectACar")} ...</option>
                                        {this.state.carList.map((car, i) => {
                                            return (
                                                <option key={car.id} value={car.id}>{car.livery_number} | {car.team_name}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                                <div className={"col-xs-3"}>
                                    <label className={"App_text"}>{this.props.t("lap")}</label>
                                    <input
                                        className={"form-control App_black_text"}
                                        style={{border: "2px solid #ed2126", height: 40}}
                                        type={"number"}
                                        placeholder={this.props.t("enterValue")}
                                        onChange={this.handleChangeLapBeingAdjusted}
                                    />
                                </div>
                                <div className={"col-xs-4"}>
                                    <label className={"App_text"}>{this.props.t("time")}</label>
                                    <input
                                        className={"form-control App_black_text"}
                                        style={{border: "4px solid " + (this.state.isLapTimeValid ? "#158500" : "#ed2126"), height: 40}}
                                        placeholder={"HH:MM:SS.XXX"}
                                        onChange={this.evaluateLapTime}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                                onClick={this.handleManualAdjustVehicleLapTime}
                                disabled={!(this.state.newLapTime > 0 && this.state.carSelectedForLapAdjust > 0 && this.state.lapBeingAdjusted > 0)}
                            >{this.props.t("ok").toUpperCase()}
                            </button>
                            <button
                                onClick={this.handleCloseModal}
                                className={"btn App_header button"}
                                style={{background: "#ff0003", color: "#FFFFFF"}}
                            >{this.props.t("cancel").toUpperCase()}
                            </button>
                        </div>
                    </Modal>
                </div>
            );
        } else {
            return null;
        }
    }
}

class MonitorCard extends PureComponent {

    render() {
        return (
            <div className={"col-xs-12 col-sm-3"}>
                <div className={"panel panel-danger"} style={{height: "100%"}}>
                    <div className={"panel-heading"} style={{height: "25%"}}>
                        <span className={"App_title"}>{this.props.monitorName}</span>
                    </div>
                    <div className={"panel-body"} style={{padding: 0, height: "40%"}}>
                        <div className={"col-xs-12 App_bold_text"} style={{fontSize: 17, paddingRight: 7, paddingLeft: 7}}>
                            {this.props.monitorDesc}
                        </div>
                    </div>
                    <div className={"panel-footer text-center"} style={{height: "35%"}}>
                        <button
                            className={"btn btn-primary button"}
                            onClick={this.props.monitorMethod}
                            disabled={this.props.isDisabled}
                        ><i className={"fas fa-external-link-alt"}/> {this.props.t("open")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(OrganizerPanel));
